<template>
    <div id="landingRoot" class="githubContainer">
        <div class="headerContainer">
            <div class="headerContent">
                <img src="../../assets/landing/github-copilot/selams.png">

                <div class="headerFlex">
                    <div class="headerText">
                        with Sela
                        <br><span class="mainTitle">GitHub and Copilot</span>
                        <br>
                        Join the 92% of developers already using GitHub!
                    </div>
                    <div class="headerForm">

                        <span class="headerFormTitle"  v-if="formStatus != 'success'">
                            Claim Your Free Consulting Today.
                        </span>

                        <form class="form land-form-wrap" @submit.prevent="sendForm" v-if="formStatus != 'success'"
                            ref="contactForm" id="contactForm">
                            <input-field class="input land-input aiInputField" label="Full Name" :required="true"
                                v-model="form.fullName" @error-message="onError"
                                :validationType="ValidationTypeEnum.AlphaBet"
                                errorText="First name can only contain letters" />
                            <input-field class="input land-input aiInputField" type="email" label="Work Email"
                                :required="true" v-model="form.email" @error-message="onError"
                                :validationType="ValidationTypeEnum.Email" errorText="Invalid Email address" />
                            <input-field class="input land-input aiInputField" label="Phone Number" :required="true"
                                v-model="form.phone" @error-message="onError" :validationType="ValidationTypeEnum.Phone"
                                errorText="Invalid phone number" />

                            <input-field class="input land-input aiInputField" label="Company" :required="true"
                                v-model="form.company" @error-message="onError"
                                :validationType="ValidationTypeEnum.Required" errorText="Company is required" />
                            <input-field class="input land-input aiInputField" label="Job Title" :required="true"
                                v-model="form.jobTitle" @error-message="onError"
                                :validationType="ValidationTypeEnum.Required" errorText="Company website is required" />

                            <select class="aiInputField" style="display:none" name="region" id="region"
                                v-model="form.region">
                                <option :value="null" disabled>Geographic Region</option>
                                <option v-for="region in $local.websiteSettings.region" :key="region._id"
                                    :value="region.name">
                                    {{ region.name }}</option>
                            </select>

                            <label class="bgl-checkbox-label">
                                <input @error-message="onError" errorText="You have to agree to the privacy policy"
                                    type="checkbox" class="bgl-checkbox" :required="true" v-model="checkboxChecked" />
                                <span class="checkbox">✔</span>
                                <span class="land-checkbox-txt">
                                    I agree to receive emails
                                </span>
                            </label>
                            <button rect :disabled="formStatus === 'sending' || this.hasFalseProp || !checkboxChecked"
                                type="submit" class="button whiteBorderButton fullWidthButton">
                                Get started
                            </button>
                            <div class="error" v-if="formStatus == 'fail'">
                                <p>An error occurred while submitting the form</p>
                            </div>
                        </form>
                        <div class="thanks" v-if="formStatus == 'success'">
                            <p>
                                <span class="thanksMain" style="color:white;">Thank You!</span><span class="yoursub">
                                    <br>Your submission has been received
                                </span>
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <div class="mainContainer">

            <span style="font-weight: 600; line-height: 28px;">
                <span style="background-color: black; color: white;">Save on GitHub and Unlock Expert AI Consulting
                    with Sela. &nbsp;</span><br>
                <br>
                Many companies are leveraging GitHub and GitHub Copilot to supercharge their R&amp;D teams, boosting
                productivity and accelerating innovation.<br>
                <br>
                At Sela, we want to offer you an opportunity to optimize your GitHub investment while unlocking
                additional
                value.</span><br>
            <br>
            <br>
            <span style="font-size: 15px; line-height: 20px;">
                <strong>By transferring your GitHub billing to Sela, you’ll
                    enjoy:</strong><br>
                <br>
                ✔&nbsp;12 Hours of AI &amp; Cloud Consulting—Our experts will help you integrate AI-driven development,
                streamline workflows, and maximize efficiency.<br>
                <br>
                ✔&nbsp;Attractive Pricing&nbsp;– Pay less for the same GitHub services you already use.<br>
                <br>
                <br>
                <br>
                <strong>WHY GitHub &amp; Copilot?</strong><br>
                <br>
                Faster Development:&nbsp;AI-powered code suggestions speed up coding and reduce errors.<br>
                <br>
                Enhanced Collaboration:&nbsp;Seamless integration with your cloud and DevOps environments.<br>
                <br>
                Security &amp; Compliance:&nbsp;Built-in security tools help safeguard your code and data.<br>
                <br>
                Switching is simple, and the benefits are immediate. Let’s ensure you’re getting the most out of GitHub
                with
                added AI and cloud expertise from Sela.<br>
                <br>
                &nbsp;
            </span>
            <br>
            <hr />

            <div class="headerContent">
                <div class="headerFlex">
                    <div class="headerText">
                        with Sela
                        <br><span class="mainTitle">GitHub and Copilot</span>
                        <br>
                        Limited spots available—start saving now!
                    </div>
                    <div class="headerForm">

                        <span class="headerFormTitle">
                            Claim Your Free Consulting Today.
                        </span>

                        <form class="form land-form-wrap" @submit.prevent="sendForm" v-if="formStatus != 'success'"
                            ref="contactForm" id="contactForm">
                            <input-field class="input land-input aiInputField" label="Full Name" :required="true"
                                v-model="form.fullName" @error-message="onError"
                                :validationType="ValidationTypeEnum.AlphaBet"
                                errorText="First name can only contain letters" />
                            <input-field class="input land-input aiInputField" type="email" label="Work Email"
                                :required="true" v-model="form.email" @error-message="onError"
                                :validationType="ValidationTypeEnum.Email" errorText="Invalid Email address" />
                            <input-field class="input land-input aiInputField" label="Phone Number" :required="true"
                                v-model="form.phone" @error-message="onError" :validationType="ValidationTypeEnum.Phone"
                                errorText="Invalid phone number" />

                            <input-field class="input land-input aiInputField" label="Company" :required="true"
                                v-model="form.company" @error-message="onError"
                                :validationType="ValidationTypeEnum.Required" errorText="Company is required" />
                            <input-field class="input land-input aiInputField" label="Job Title" :required="true"
                                v-model="form.jobTitle" @error-message="onError"
                                :validationType="ValidationTypeEnum.Required" errorText="Company website is required" />

                            <select class="aiInputField" style="display:none" name="region" id="region"
                                v-model="form.region">
                                <option :value="null" disabled>Geographic Region</option>
                                <option v-for="region in $local.websiteSettings.region" :key="region._id"
                                    :value="region.name">
                                    {{ region.name }}</option>
                            </select>

                            <label class="bgl-checkbox-label">
                                <input @error-message="onError" errorText="You have to agree to the privacy policy"
                                    type="checkbox" class="bgl-checkbox" :required="true" v-model="checkboxChecked" />
                                <span class="checkbox">✔</span>
                                <span class="land-checkbox-txt">
                                    I agree to receive emails
                                </span>
                            </label>
                            <button rect :disabled="formStatus === 'sending' || this.hasFalseProp || !checkboxChecked"
                                type="submit" class="button whiteBorderButton fullWidthButton">
                                Register Now!
                            </button>
                            <div class="error" v-if="formStatus == 'fail'">
                                <p>An error occurred while submitting the form</p>
                            </div>
                        </form>
                        <div class="thanks" v-if="formStatus == 'success'">
                            <p>
                                <span class="thanksMain"  style="color:black;">Thank You!</span><span class="yoursub">
                                    <br>Your submission has been received
                                </span>
                            </p>
                        </div>

                    </div>
                </div>
            </div>

            <div class="footerText">
                For additional information, info@selacloud.com | US: +1 484-369-0439 Israel: | +972 3-6176666 or contact
                us through our website
                © 2025 All Rights Reserved.
            </div>

            <div class="social">
                <a href="https://www.linkedin.com/company/sela-group/" data-service-name="linkedin" target="_blank"
                    data-font-size="15" data-font-size-type="px" data-line-height="20px"><img data-original-width=""
                        data-original-height="" alt="LinkedIn" title="LinkedIn" height="" width="" border="0"
                        style="border: 0pt none; max-width:px; width:px; height:px;"
                        src="https://cdn-media.web-view.net/templates/builder/public/Social/FindUs/FindUs_small_in_circle_BOW.png"
                        id="bl_18"></a>
                <a href="https://www.facebook.com/selacloud" data-service-name="facebook" target="_blank"
                    data-font-size="15" data-font-size-type="px" data-line-height="20px"><img data-original-width="26"
                        data-original-height="26" alt="Facebook" title="Facebook" height="26" width="26" border="0"
                        style="border: 0pt none; max-width:26px; width:26px; height:26px;"
                        src="https://cdn-media.web-view.net/templates/builder/public/Social/FindUs/FindUs_small_fb_circle_BOW.png"
                        id="bl_19"></a>
                <a href="https://selacloud.com/" data-service-name="website" target="_blank" data-font-size="15"
                    data-font-size-type="px" data-line-height="20px"><img data-original-width="26"
                        data-original-height="26" alt="Website" title="Website" height="26" width="26" border="0"
                        style="border: 0pt none; max-width:26px; width:26px; height:26px;"
                        src="https://cdn-media.web-view.net/templates/builder/public/Social/FindUs/FindUs_small_we_circle_BOW.png"
                        id="bl_20"></a><a href="mailto:hellocloud@sela.co.il" data-service-name="mail" target="_blank"
                    data-font-size="15" data-font-size-type="px" data-line-height="20px"><img data-original-width="26"
                        data-original-height="26" alt="Email Us" title="Email Us" height="26" width="26" border="0"
                        style="border: 0pt none; max-width:26px; width:26px; height:26px;"
                        src="https://cdn-media.web-view.net/templates/builder/public/Social/FindUs/FindUs_small_ma_circle_BOW.png"
                        id="bl_21"></a>


            </div>
        </div>


    </div>
</template>


<script>
import axios from 'axios';

export default {
    metaInfo() {
        return {
            ssrAppId: "sela",
            ...this.seo({
                title: this.lp.title,
                description: this.lp.blurb,
                image: this.event?.thumbnail?.imageURL || this.lp.cover?.imageURL,
            }),
        };
    },
    components: {

    },
    data: () => ({
        now: new Date(),
        formStatus: "",
        form: {
            pageName: "",
            pageId: "",
            fullName: "",
            email: "",
            company: "",
            phone: "",
            jobTitle: "",
            region: null,
            utmsource: "",
        },
        checkboxChecked: false,
        ValidationTypeEnum: {
            AlphaBet: /^[a-zA-Z ]+$/,
            Email: /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/,
            Phone: /^(\+)?(?:[0-9-()/.\s?]){6,15}[0-9]{1}$/,
            Required: /.+/
        },
        hasFalseProp: false,
        formErrors: {},
    }),

    watch: {

    },
    computed: {
        lp() {
            const id = "github-copilot";
            const lp = this.$local.landingPages?.find((c) => c.slug == id);

            return lp
        },
    },
    mounted() {
        console.log("ver 9.4");
    },
    methods: {
        onError(errorObj) {
            this.formErrors[errorObj.label] = errorObj.validation;

            this.setFalseProp();
        },
        async sendForm() {
            try {
                this.setFalseProp();
                if (this.hasFalseProp) {
                    return; // Stop the form submission if there are errors
                }
                this.formStatus = "sending";
                this.form.pageName = this.lp.name;
                this.form.pageId = this.lp._id;

                let utm_source = sessionStorage.getItem('utm_source');
                if (utm_source)
                    this.form.utmsource = utm_source;

                await axios.post(
                    '/.netlify/functions/submitLandingDetails',
                    this.form
                );
                this.formStatus = "success";
            } catch (err) {
                console.log(err.response.data);
                this.formStatus = "fail";
            }
        },
        setFalseProp() {
            this.hasFalseProp = Object.values(this.formErrors).includes(false);
        },
        replaceUrlInThankyouText(htmlContent) {
            htmlContent = htmlContent.replace(/@FILE_URL@/g, this.lp.pDFForDownload.imageURL);
            console.log(htmlContent);
            return htmlContent;
        }
    },
    name: "Landing",
};

</script>

<style>
#app .githubContainer {
    line-height: 24px !important;
}

#app .githubContainer .thanks{
    text-align: center;
}

#app .githubContainer .footerText {
    text-align: center;
    font-size: 15px;
    color: black;
    padding-top: 50px;
}

.githubContainer .bgl-checkbox-label {
    margin-bottom: 0;
    font-size: 15px;
    line-height: 27px;
}

#landingRoot .githubContainer .button::after {
    content: '' !important;
    width: 0 !important;
    height: 0 !important;
}

.githubContainer .input-wrapper label.hasFocus {
    opacity: 0 !important;
}

.githubContainer .error {
    padding-top: 10px !important;
}

@media (max-width: 912px) {
    .input-wrapper {
        margin-bottom: 0 !important;
    }
}
</style>

<style scoped>
.thanksMain {
    font-size: 50px;
}

.yoursub {
    font-size: 15px;
    color: #606060;
}

.input {
    height: 40px !important;
    border: 1px solid #ccc;
    border-radius: 4px !important;
}

.social {
    text-align: center;
    padding-top: 20px;
}

/* ::v-deep .input input {
    border-radius: 4px !important;
} */


::v-deep .error {
    padding-top: 12px !important;
}

::v-deep .input-wrapper label {
    font-size: 14px;
    top: 7px;
    font-weight: 300;
}

hr {
    border: 1px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: #797979;
}

.headerFormTitle {
    color: white;
    font-weight: 200;
    font-size: 15px;
    display: inline-block;
    padding-bottom: 10px;
}

.mainContainer,
.landingFormContainer,
.agenda,
.video-container {
    max-width: 1440px;
    width: 100%;
    margin: auto;
}

.lpHeaderTop,
.lpHeaderBottom,
.mainContainer,
.agenda {
    width: 100%;
}

.headerContainer {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    min-height: 316px;
    background-image: url('../../assets/landing/github-copilot/cat.jpg');
    margin-top: 0px !important;
    background-repeat: no-repeat;
    background-size: cover !important;
    -webkit-background-size: cover !important;
    background-position: 50% 0px;
    position: relative;
    padding-bottom: 50px;
}


.mainContainer,
.headerContent {
    margin: auto;
}

.headerContent:first-child {
    padding-top: 60px;
}

.headerFlex {
    display: flex;
    padding-top: 65px;
    padding-bottom: 15px;
    gap: 3%;
}

.headerText {
    width: 63%;
    font-weight: 300;
    font-size: 28px;
    line-height: 38px;
    letter-spacing: 0.3px;
    color: white;
    padding-bottom: 30px;
}

.headerForm {
    width: 30%;
}

.land-checkbox-txt a {
    font-size: 15px;
}

.mainContainer .headerText,
.mainContainer .land-checkbox-txt,
.land-checkbox-txt a {
    color: black;
}



.mainTitle {
    font-size: 63px;
    font-weight: 400;
    line-height: 1.1;
}

.lpHeaderTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ffffff;
    height: 90px;
}


.lpHeaderBottom {
    display: flex;
    flex-direction: column;
    font-family: "Poppins", serif;
    font-size: 20px;
    font-weight: 300;
    max-width: 80%;
    height: 65%;
    justify-content: space-around;
    padding-top: 7%;
}

.mainTitle {
    width: 504px;
}

.headerBold {
    font-size: 25px;
    font-weight: 700;
    letter-spacing: 0.3px;
}

.topLogo {
    background-image: url('../../assets/landing/google-otc/google-sela-logo.png');
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: cover;
    width: 264px;
    height: 30px;
}

#landingRoot .button {
    background-color: white;
    color: #2E3033;
    font-family: "Poppins", serif;
    font-size: 16px;
    font-weight: 400;
    padding: 8px;
    min-width: 181px;
    cursor: pointer;
    border: 1px solid #101010;
}

#landingRoot .button:not([rect]) {
    border-radius: 50px;
}


#landingRoot .button:disabled {
    color: grey;
    background-color: #d3d3d3;
    cursor: auto;
}


#landingRoot .button::after {
    content: url('../../assets/landing/google-otc/arrow-right.svg');
    width: 24px;
    height: 24px;
    top: 3px;
    position: relative;
    display: inline-block;
}

#landingRoot .button:disabled::after {
    opacity: 0.6;
}

.mobile-only {
    display: none;
}

.desktop-only {
    display: inline-block;
}


.mainContainer {
    font-family: arial, sans-serif;
    font-size: 20px;
    font-weight: 300;
    color: rgb(96, 96, 96);
    padding-top: 90px;
    background-color: white;
    max-width: 900px;
}

.agenda {
    display: flex;
    border-bottom: 1px solid #ffffff;
    padding-bottom: 100px;
}

.agendaTitle {
    font-family: "Lexend";
    font-size: 120px;
    font-weight: 200;
    line-height: 60px;
    flex: 50%;
}

.agendaText {
    flex: 50%;
    font-family: "Poppins", serif;
    font-size: 17px;
    line-height: 24px;
    font-weight: 300;
}

#customLP .formLeft {
    justify-content: flex-start;
}

.formTitle {
    font-family: "Lexend";
    font-size: 38px;
    font-weight: 200;
    letter-spacing: 1.3px;
    max-width: 360px;
}

.formSubTitle {
    font-size: 23px;
    font-weight: 300;
    letter-spacing: 1.3px;
    color: var(--light-blue);
}

.new-line {
    font-weight: 200;
    color: var(--light-blue);
}

.video-container {
    position: relative;
    width: 100%;
}

video {
    width: 100%;
    height: auto;
    display: block;
}

.footerbg {
    /* width: 100%; */
    width: 99.8%;
    margin: auto;

    height: auto;
    max-height: 680px;
    display: block;
}

.overlay {
    position: absolute;
    top: -5px;
    left: 0;
    width: 100%;
    pointer-events: none;
}

.overlayText {
    font-family: "Lexend";
    font-size: 75px;
    font-weight: 600;
    color: #ffffff;
    text-shadow: 4px 4px 6px rgba(0, 0, 0, 0.6);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    white-space: nowrap;
}

.otc-footer {
    width: 100%;
    height: 163px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.otc-footer img {
    width: 335px;
    height: 42px;
}

@media screen and (max-width: 1200px) {
    .overlayText {
        white-space: wrap;
        text-align: center;
        font-size: 65px;
    }
}

@media screen and (max-width: 991px) {



    .mainContainer {
        font-size: 17px;
        padding-top: 40px;
        line-height: 28px;
        min-height: 600px;
    }

    .agenda {
        flex-direction: column;
    }

    .lpHeaderBottom {
        max-width: 90%;
        gap: 40px;
    }

    /* .headerText {
        font-size: 18px;
    } */

    .headerBold {
        font-size: 17px;
        line-height: 27px;
    }


    .lpHeaderTop,
    .lpHeaderBottom,
    .mainContainer,
    .agenda,
    #customLP .formRight,
    #customLP .formContainer .formLeft {
        width: 100%;
        padding-left: 35px;
        padding-right: 35px;
    }

    #customLP .formContainer .formRight {
        margin: 0;
        padding-bottom: 100px;
    }


    #customLP .formRight .pairOfFields {
        flex-direction: column;
    }


    #customLP .formRight .pairOfFields .input {
        flex: auto;
    }

    .agendaTitle {
        flex: 100%;
        font-size: 80px;
        line-height: 133%;
        padding-top: 50px;
        padding-bottom: 50px;
    }

    .agendaText {
        flex: 100%;
        font-size: 16px;
        line-height: 27px;
    }


    .topLogo {
        background-size: contain;
        width: 219px;
    }

    .agendaTitle {
        font-size: 70px;
    }


    .desktop-only {
        display: none;
    }

    .mobile-only {
        display: block;
    }

    .mobileBlock {
        display: block;
    }

    .formTitle {
        font-size: 29px;
        line-height: 126%;
        text-align: left;
    }

    .overlayText {
        font-size: 37px;
        line-height: 42px;
        width: 90%;
    }

    .otc-footer {
        height: 82px;
    }

    .otc-footer img {
        width: 167px;
        height: auto;
    }
}


@media screen and (max-width: 767px) {
    .headerContainer {
        flex-direction: column;
        gap: 20px;
    }

    .headerFlex {
        flex-direction: column;
    }

    .headerText,
    .headerForm {
        width: 100%;
    }

    .headerContainer {
        padding: 25px;
    }

    .headerContent {
        padding-top: 60px;
    }

}

/* -------------------------- */

.land-form-thanks {
    max-width: 90%;
    margin: auto;
    background: transparent;
    color: white;
    margin-top: 100px;
}


#requestdemo {
    max-width: 1000px;
    height: 1000px;
    margin: auto;
}


#requestdemo {
    scroll-margin-top: 100px;
}


.video {
    margin-right: 34px;
}

.video-shadow {
    box-shadow: rgb(0, 219, 232) 25px 25px;
    width: 675px;
}


.demo-title {
    display: flex;
    margin: auto;
    margin-top: 20px;
    gap: 20px;
}

.button-container {
    display: flex;
    justify-content: space-between;
}

.button-container input {
    height: 54px;
    margin: 15px;
}

.demo-title img {
    max-width: 120px;
}

.main-container {
    display: flex;
    flex-direction: column;
}







@media screen and (max-width: 479px) {

    .mobile-title {
        margin: 20px auto;
        border: 10px solid var(--light-blue);
        padding: 14px;
        width: 90;
        text-align: center;
    }

    .mobile-only {
        display: block;
    }

    .desktop-only {
        display: none;
    }

    ::v-deep .btn {
        padding: 12px 22px;
    }
}



@media screen and (max-width: 1200px) {
    .agendaTitle {
        font-size: 80px;
    }
}
</style>